var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{key:_vm.ID,attrs:{"value":_vm.value,"checked":_vm.value},on:{"input":_vm.test},nativeOn:{"click":function($event){return _vm.update(_vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }